import React, { useState } from "react";
import DateRangePicker from "../../RouteManagement/components/dateRangePicker";
import {
  Button,
  Drawer,
  TextField,
  MenuItem,
  Slide,
  IconButton,
  Dialog,
} from "@material-ui/core";

import "./datePicker.scss";

import Collapse from "@material-ui/core/Collapse";
import EventIcon from "@material-ui/icons/Event";

import { withStyles } from "@material-ui/core/styles";

const DateButton = withStyles({
  root: {
    width: "100%",
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
})(Button);
export default function DatePicker({
  label,
  value,
  onChangeDate,
  minDate,
  maxDate,
  overlayMode,
}) {
  const [startDateCollapsed, setStartDateCollapsed] = useState(false);
  const toggleStartDateView = () => setStartDateCollapsed(!startDateCollapsed);

  return (
    <div className="custom-date-picker">
      <DateButton className="start-date" onClick={toggleStartDateView}>
        <p>{label}</p>
        <h2 style={{ opacity: value === "" ? 0.6 : 1 }}>
          {/* {format(this.state.startDate, "MM LLL yyyy")}{" "} */}
          {new Date(value).toDateString()}
          <EventIcon style={{ marginLeft: 5 }} />
        </h2>
      </DateButton>
      {overlayMode && overlayMode === "modal" ? (
        <Dialog
          onClose={toggleStartDateView}
          aria-labelledby="simple-dialog-title"
          open={startDateCollapsed}
        >
          <h4 style={{ fontSize: 23, paddingLeft: 16 }}>{label}</h4>
          <DateRangePicker
            onChangeDate={(e) => {
              onChangeDate(e);
              toggleStartDateView();
            }}
            minDate={minDate}
            maxDate={maxDate}
          />
        </Dialog>
      ) : (
        <Collapse in={startDateCollapsed}>
          <DateRangePicker
            onChangeDate={(e) => {
              onChangeDate(e);
              toggleStartDateView();
            }}
            minDate={minDate}
            maxDate={maxDate}
          />
        </Collapse>
      )}
    </div>
  );
}
